import { fetchWrapper } from '../../utils';

export class conduct {
  static baseUrl = process.env.REACT_APP_BASE_API + 'professor';

  static async getConducts(params) {
    const url = `${this.baseUrl}/conduct/get`;
    return await fetchWrapper.post(url, params);
  }

  static async createIndividualConduct(params) {
    const url = `${this.baseUrl}/conduct/individualCreate`;
    return await fetchWrapper.post(url, params);
  }

  static async createGroupConduct(params) {
    const url = `${this.baseUrl}/conduct/groupCreate`;
    return await fetchWrapper.post(url, params);
  }

  static async generateReport(params) {
    const url = `${this.baseUrl}/conduct/report`;
    return await fetchWrapper.post(url, params);
  }

}
